import { MymachineItem } from "./mymachine-response";

const tableTooltip = ({ number, discontinued }: MymachineItem): any => {
    if (!discontinued) return "";
    return `
    <ux-iws-discontinuation-tooltip
        tooltip-identifier="${number}"
        type="${discontinued.type}"
        status="${discontinued.status}"
        extended-support="${discontinued.extendedSupport}"
        head="${discontinued.head}"
        text="${discontinued.text}"
        link="${discontinued.link}"
        link-text="${discontinued.linkText}"
    ></ux-iws-discontinuation-tooltip>`;
};

export default tableTooltip;
